export default __webpack_public_path__ + "static/media/water.8eca703d.png";